module.exports = __webpack_public_path__ + "static/media/palmeira-acuri_thumb.167378ab.jpg";